import {fnErrorMsg} from "../jquery-functions-library";

export var fnDashboardPrimaryEmployee = function () {

  $.ajax({
      type: 'GET',
      url: '/getPrimaryEmployee',
      success: function (response) {
        $('#primaryEmployeeContainer').html(response);
      },
      error: fnErrorMsg
  });

};
